module.exports = __webpack_public_path__ + "img/index7.3bbe6d06.png";